import { X } from 'lucide-react';
import { ModulSihirbaziKart } from '@features/ayarlar';

interface Props {
  open: boolean;
  onClose: () => void;
}

export function ModulSihirbaziModal({ open, onClose }: Props) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div
        className="w-full max-w-md max-h-[90vh] overflow-y-auto rounded-lg bg-card shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b px-6 py-4">
          <h2 className="text-lg font-semibold">Menü / Modül Sihirbazı</h2>
          <button onClick={onClose} className="rounded p-1 hover:bg-muted">
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="p-4">
          <ModulSihirbaziKart embedded />
        </div>
      </div>
    </div>
  );
}
